import React from "react";

function SuccesStories(props) {

  return (
    <div className="blog-grid-title1">
        <div className="container">
            <div className="section-title">
                <h2>Digital Thinking</h2>
                <p>Our experts’ opinions and perspective on technology-lead digital transformation.</p>
            </div>
        </div>
    </div>
  );
}

export default SuccesStories; 